import { request } from "../utils/request"


/**
 * dashboard
 * 企业数据
 * @returns 
 */
export const getCmpDashboard = () => {
    return request.get(`/company/dashboard`)
}
/**
 * dashboard
 * 项目数据
 * @returns 
 */
export const getProjDashboard = () => {
    return request.get(`/project/dashboard`)
}

/**
 * 终端数据
 * @returns 
 */
export const getTerminalDashboard = () => {
    return request.get(`/terminal/dashboard`)
}

/**
 * 传感器数据
 * @returns 
 */
export const getSensorDashboard = () => {
    return request.get(`/sensor/dashboard`)
}
/**
 * 传感器类型统计
 * @returns 
 */
export const getSensorStatistics = (params?: { cmp?: number, proj?: number }) => {
    return request.get(`/sensor/dashboard/statistic`, { params })
}

/**
 * 上报数据
 * @returns 
 */
export const getDataDashboard = () => {
    return request.get(`/data/dashboard`)
}
/**
 * 资源
 * @returns 
 */
export const getAssetDashboard = () => {
    return request.get(`/assets/dashboard`)
}
/**
 * 日志活跃度
 * @returns 
 */
export const getLogDashboard = () => {
    return request.get(`/log/dashboard`)
}
/**
 * 监测点位
 * @returns 
 */
export const getPointDashboard = (params?: { cmp?: number, proj?: number }) => {
    return request.get(`/point/dashboard`, { params })
}
/**
 * 监测点位的报警信息
 * @param params 
 * @returns 
 */
export const getPointDashboardWarning = (params?: { cmp?: number, proj?: number }) => {
    return request.get(`/point/dashboard/warning`, { params })
}
